import { render, staticRenderFns } from "./wechat_login.vue?vue&type=template&id=211f98ee&"
import script from "./wechat_login.vue?vue&type=script&lang=js&"
export * from "./wechat_login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports